<template>
    <div class="wrapper default">
        <div class="container-fluid">
            <div class="main-content col-12 col-md-12 col-lg-12">
                <div class="top-logo-hh">
                    <router-link to="/" class="logo">
                        <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 order-md-12">
                    <div class="account-box">

                        <div class="account-box-title">
                            آیا عضو فروشگاه ایران مارت نیستید؟
                            <p class="p-f-f">
                                از لینک زیر برای عضویت اقدام کنید.
                            </p>
                        </div>
                        <div>

                        </div>
                        <div class="account-box-content">
                            <div class="row">
                                <div class="col-12 col-md-12 col-lg-12">
                                    <div class="account-benefits">
                                        <h3 class="faq-title icon-plus">
                                            مزایای عضویت در ایران مارت
                                        </h3>
                                        <ul class="faq-text">
                                            <li>ایجاد پنل کاربری برای مشاهده سفارشات و محصولات</li>
                                            <li>ذخیره سازی اطلاعات سفارشات شما</li>
                                            <li>سرعت بخشی به فرایند خرید</li>
                                            <li>اطلاع از قیمت فروش محصولات</li>
                                            <li>خرید بی دغدغه و آسان و امکان عودت کالا</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-lg-12">
                                    <div class="form-account-row form-account-submit">
                                        <div class="parent-btn">
                                            <router-link to="/register" class="dk-btn dk-btn-info">
                                                ثبت نام
                                                <i class="now-ui-icons users_circle-08"></i>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div class="main-content col-12 col-md-6 col-lg-6 order-md-1">
                    <div class="account-box">
                        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                            <img style="position:absolute;top:50%;left:42%;z-index:100" src="/assets/img/loader/loader.svg" />
                        </div>

                        <div class="account-box-title text-right">اگر عضو هستید با واردکردن اطلاعات کاربری خود وارد فروشگاه شوید</div>
                        <div class="account-box-content">
                            <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                <li v-for="error in errors.all()">{{ error }}</li>
                            </ul>
                            <form @submit.prevent="validateForm" class="form-account">
                                <div class="row">
                                    <div class="col-12 col-md-6 col-lg-6">
                                        <div class="form-account-title">تلفن همراه</div>
                                        <div class="form-account-row">
                                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                            <input name="username" class="input-field" type="text" v-model="user.UserName" v-validate="{ required: true, regex: /^09\d{9}$/ }" data-vv-as="شماره موبایل"
                                                   placeholder="شماره موبایل خود را وارد نمایید">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6">
                                        <div class="form-account-title">
                                            رمز عبور

                                            <router-link to="/forgetPassword" tag="a" class="btn-link-border form-account-link">
                                                رمز
                                                عبور خود را فراموش
                                                کرده ام
                                            </router-link>
                                        </div>

                                        <div class="form-account-row">
                                            <label class="input-label">
                                                <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                            </label>
                                            <input name="password" class="input-field" type="password" v-model="user.Password" v-validate="{required: true , min:4 , max: 12}" data-vv-as="رمز عبور"
                                                   placeholder="رمز عبور خود را وارد نمایید">
                                        </div>
                                    </div>
                                    <div class="flex w-100 margin-t-25">
                                        <div class="form-account-row form-account-submit">
                                            <div class="parent-btn">
                                                <button type="submit" class="dk-btn dk-btn-info">
                                                    ورود به ایران مارت
                                                    <i class="fa fa-sign-in"></i>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>




                            </form>
                        </div>
                        <div class="account-box-footer">
                            <!--<span>کاربر جدید هستید؟</span>

                <router-link to="/register" tag="a" class="btn-link-border">
                    ثبت‌نام کنید
                </router-link>-->
                            <div>
                                <router-link class="btn-redirect-page" to="/">بازگشت به فروشگاه</router-link>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
        <mini-footer></mini-footer>
    </div>

</template>

<script>
    import miniFooter from "../../sharedComponents/footerComponents/miniFooter.vue";
    import { httpPromise } from "../../../module/httpUtility.js";
    import { initialSite } from "../../../module/initialSite"
    export default {
        data() {
            return { user: {}, isShowSppiner: false}
        },
        components: {
            'mini-footer': miniFooter
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/Account/Login', 'post', JSON.stringify(this.user),
                            response => {
                                localStorage.setItem('accessToken', response.data.Value.Token);
                                this.$store.commit('setUserFullName', response.data.Value.UserFullName);
                                var path = IsNullOrEmptyString(this.$route.query.returnUrl) ? '/' : this.$route.query.returnUrl;
                                this.isShowSppiner = false;
                                window.location.href  = path ;
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            resetForm() {
                this.user = {};
                this.$validator.reset();
                this.$validator.errors.clear();
            }
        },
        beforeMount: function () {
            createPageTitle('ورود به سیستم');
            initialSite(this);
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        } ,
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                if (isUserLogined())
                    vm.$router.push('/');
            });
        }
    }
</script>

<style scoped>
    .top-logo-hh {
        background: #fff;
        width: auto;
        margin: 70px auto;
    }

        .top-logo-hh .logo img {
            height: 38px;
        }

        .top-logo-hh .logo {
            width: 156px;
            height: 60px;
            position: absolute;
            left: 50%;
            bottom: -20%;
            transform: translate(-50%);
            text-align: center;
            line-height: 60px;
        }
    .margin-t-25 {
        margin-top:25px;
    }
    .account-box-title .p-f-f {
        color: #909090;
        font-size: 13px;
    }
    .account-box {
        width: auto;
    }

    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }

    .account-benefits ul li::before {
        content: '\f00c';
        font-family: FontAwesome;
        margin: 0 -10px 0 5px;
        width: 1.2em;
        color: #333;
        font-size: 150%;
        vertical-align: middle;
    }

    .account-benefits ul li {
        color: #747474;
    }

    .icon-plus::before {
        font-family: FontAwesome;
        content: "\f067";
    }

    .faq-title {
        margin-bottom: 5px;
        margin-top: 30px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .account-box {
            margin: 35px auto;
        }
    }
</style>